// angular
import { Component } from '@angular/core';

// @ts-ignore
import json from './languages.json';
import { Location } from '@angular/common';
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';

interface LanguageInfo {
  englishName: string;
  name: string;
  code: string;
  href: string;
}

/**
 * See here for style info:
 * https://design-system.service.gov.uk/
 */
@Component({
  selector: 'aa-languages-component',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss'],

})
export class QnaLanguagesComponent extends AbstractQnaComponent {

  readonly languages: LanguageInfo[] = [];
  readonly groups: LanguageInfo[][] = [];

  constructor(navigation: QnaNavigationService) {
    super(navigation, 'Contact');

    for (const item of json) {
      this.languages.push({
        ...item,
        href: QnaLanguagesComponent.generateLink(navigation.baseUrl, item.code)
      });
    }

    const groupCount = 3;
    const chunkSize = Math.ceil(this.languages.length / groupCount);
    let start = 0;
    for (let i = 0; i < groupCount; i++) {
      const end = start + chunkSize;
      this.groups.push(this.languages.slice(start, end));
      start = end;
    }
  }

  static generateLink(baseUrl: string, code: string) {
    return `https://translate.google.co.uk/translate?sl=en&tl=${code}&u=${baseUrl}`;
  }
}
